import { FunctionComponent, memo, useMemo } from "react";
import { andList } from "@edgetier/client-components";

import { formatPhrases } from "./text-anomaly-description.utilities";

import { IProps } from "./text-anomaly-description.types";
import "./text-anomaly-description.scss";

/**
 * Summarise a text anomaly.
 * @param props.anomalyEvents All events that have happened in an anomaly.
 * @returns                   Description of an anomaly.
 */
const TextAnomalyDescription: FunctionComponent<IProps> = ({ anomalyEvents }) => {
    const { excessPhrases, listedPhrases, isAbbreviated } = useMemo(() => formatPhrases(anomalyEvents), [
        anomalyEvents,
    ]);

    return (
        <p>
            Increase in interactions about {andList(listedPhrases, { quote: true })}
            {isAbbreviated && <> and {excessPhrases} more terms</>}.
        </p>
    );
};

export default memo(TextAnomalyDescription);
